/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import { Component, Input, Output, EventEmitter } from "@angular/core";
import uiCore = require("../core/uicore");

export class WorkGroupButtons implements uiCore.IDirective {

    constructor(..._args: any[]) {
    }

    public static ComponentDescription: uiCore.IStandardComponentDescription = {
        DirectiveId: "workgroupbuttons",
        Template: require("./workgroup.buttons.html"),
        AngularDependencies: [uiCore.ScopeDependency],
        Bindings: {
            workgroups: "<",
            onWorkGroupAdded: "<",
        }
    };

    public selectedWorkGroup: Nema.Crew.Model.WorkGroup;

    public onWorkGroupAdded: (addedPersonIds: number[]) => void;

    public addSelectedWorkGroup() {
        const addedPersonIds = this.selectedWorkGroup.WorkGroupPersons.map(workGroupPerson => workGroupPerson.Person).filter(person => !!person && person.Active).map(person => person.Id);
        this.onWorkGroupAdded(addedPersonIds);
    }
}

@Component({
    selector: "crew-workgroup-buttons",
    template: require('./workgroup-buttons.component.html')
})
export class WorkgroupButtonsComponent {

    @Input()
    workgroups: Nema.Crew.Model.WorkGroup[];

    @Input()
    workGroupPersonIdSelector: (workGroup: Nema.Crew.Model.WorkGroup) => number[];

    selectedWorkGroup: Nema.Crew.Model.WorkGroup;

    @Output()
    onWorkGroupAdded = new EventEmitter<number[]>();

    addSelectedWorkGroup(): void {
        const addedPersonIds = this.workGroupPersonIdSelector ?
            this.workGroupPersonIdSelector(this.selectedWorkGroup) :
            this.selectedWorkGroup.WorkGroupPersons.map(workGroupPerson => workGroupPerson.Person).filter(person => !!person && person.Active).map(person => person.Id);
        this.onWorkGroupAdded.emit(addedPersonIds);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/workgroup.buttons.ts